var BodyController = (function () {
    function BodyController($login, env, socket, $scope, notify, $state, $stateParams, config, topic, $rootScope, settings, status, searchSubmit, Dialog, $window, $timeout) {
        var _this = this;
        this.$login = $login;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.notify = notify;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.config = config;
        this.topic = topic;
        this.$rootScope = $rootScope;
        this.settings = settings;
        this.status = status;
        this.searchSubmit = searchSubmit;
        this.Dialog = Dialog;
        this.$window = $window;
        this.$timeout = $timeout;
        this.topic.loaded = { config: false, topic: false, gpp_valid: false, settings: false, program: false, userProfile: false };
        socket.forward('message', $scope);
        this.$scope.$on('socket:message', function (event, data) {
            _this.message(event, data);
        });
        socket.forward('redirect.login', $scope);
        this.$scope.$on('socket:redirect.login', function (event, data) {
            /*if ('400,403,404,500,login'.indexOf(this.$state.current.name) < 0) {
              this.$window.location.href = '/403';
            }*/
            if (_this.env.user.loggedIn) {
                _this.env.revokeUser();
                // 1 second added, becaues window
                _this.$timeout(function () {
                    _this.$window.location.href = '/logout';
                }, 1000);
            }
        });
        socket.forward('federal.delete', $scope);
        this.$scope.$on('socket:federal.delete', function (event, data) {
            _this.topic.usFed.beingDeleted = false; //turn off
            if (data.success) {
                var items = {
                    icon: 'INFO',
                    message: 'The Disbursement content has been successfully deleted from DMT, and notification sent to System Admin for their records.<br><br><b>NOTE:</b> Despite the content being deleted, summary details of the Disbursement will still be avaiable via the Custom Reports. &nbsp;Click <b>OK</b> to return to My Queue.',
                    title: 'US Federal Deletion'
                };
                //Prompt
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    $state.go('queue', { id: 'myqueue' }); ///go home
                });
            }
        });
        socket.forward('status.enable_action', $scope);
        this.$scope.$on('socket:status.enable_action', function (event, data) {
            _this.status.disableApproveButtons = false; //make action button available again
        });
        socket.forward('dispute.error', $scope);
        this.$scope.$on('socket:dispute.error', function (event, data) {
            _this.status.disableApproveButtons = false; //make action button available again
        });
        socket.forward('dispute.success', $scope);
        this.$scope.$on('socket:dispute.success', function (event, data) {
            _this.status.disableApproveButtons = false;
            //Ask user if they wanna open the new dispute
            var items = {
                icon: 'QUESTION',
                message: 'Dispute <b>' + data.unid + '</b> has been successfully created.<br><br>Do you want to open it now?',
                title: 'New Dispute'
            };
            //Ask it...
            _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                //If clicked no
                if (!dResult.confirm) {
                    //Update the topic with the new history element and append the dispute number
                    _this.topic.addDisputeDetails(data);
                    _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                }
                else {
                    _this.$state.go('detail.general', {
                        id: data.unid.substring(4)
                    });
                }
            });
        });
        //Listener for when prrogam profile is sent
        this.socket.forward('config.program', this.$rootScope);
        this.$rootScope.$on('socket:config.program', function (event, data) {
            _this.config.setProgramProfile(data);
            _this.topic.fromConfigProgram();
        });
        // topic data
        this.socket.forward('topic.update', this.$scope);
        this.$scope.$on('socket:topic.update', function (event, data) {
            if (data.success && angular.isDefined(data.results.topic) && angular.isDefined(data.results.topic._id) &&
                angular.isDefined(data.results.edit)) {
                _this.topic.checksData = data.results.checksData;
                _this.topic.calculation = data.results.calculation;
                _this.topic.siteIdData = data.results.siteIdData;
                _this.topic.salesAssistData = data.results.salesAssistData;
                _this.topic.goeHistoryCheck = data.results.goeHistoryCheck;
                _this.topic.hasCtlSo = Boolean(data.results.hasCtlSo);
                _this.topic.externalLinks = data.results.externalLinks;
                _this.topic.inbound = data.results.checksData.inbound;
                _this.topic.clearTopic(_this.topic.getId(data.results.topic._id));
                _this.topic.updateEditOptions(data.results.edit, data.results.topic.program);
                _this.topic.updateTopic(data.results.topic, false, []);
                _this.topic.updateTopicWithoutCalc(data.results.gpp_live);
                _this.topic.checkSubStatus();
                _this.topic.isNewUI();
            }
            else {
                _this.topic.clearTopic(undefined);
                var items = {
                    title: 'Disbursement Retrieval Error',
                    message: 'There was a problem retrieving the Disbursement details:<br><br><b>' + (angular.isDefined(data.error.message) ? data.error.message : data.error) + '</b>',
                    icon: 'ERROR'
                };
                _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                    _this.$state.go('queue', {
                        id: _this.env.getDefaultQueue()
                    });
                });
            }
        });
        // Just a dummy chcek, if all worked
        this.socket.forward('topic.reponsefromserver', this.$scope);
        this.$scope.$on('socket:topic.reponsefromserver', function (event, data) {
            alert('Alert is ' + data._id);
        });
        // this is called when status is updated
        this.socket.forward('status.updateStatus', this.$scope);
        this.$scope.$on('socket:status.updateStatus', function (event, data) {
            if (angular.isDefined(data.result.data) && angular.isDefined(data.eos)) {
                _this.status.mainStatusChange = false;
                _this.status.eligDecisionFired = false;
                //If it's not a rollback, refresh the elements that have changed
                if (!data.rollback) {
                    angular.copy(_this.topic.topic_ext, _this.topic.temp_ext);
                    _this.topic.updateEditOptions(data.eos, _this.topic.topic.program);
                    _this.topic.updateTopic(data.result.data, true, []);
                    _this.topic.checkSubStatus();
                    _this.status.sendEmail(_this.topic.topic._id, _this.topic.topic.opp);
                    _this.topic.updatePartialSocketStatus(['status'], '');
                    _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                }
                else {
                    //If it is a rollback...don't bother, just reload the page since many things may have changed that are beyond the
                    //(current) capability of the $10k
                    //Reload!!
                    _this.topic.reloadDisbursement(_this.$stateParams.id);
                }
            }
            else {
                console.log('wrong response on status change');
            }
        });
        // message when the file was uploaded
        this.socket.forward('upload.confirmation', this.$scope);
        this.$scope.$on('socket:upload.confirmation', function (event, data) {
            if (data !== undefined) {
                if (data.type === 'delete') {
                    _this.topic.deleteFiles(data.fileNames);
                }
                if (data.type === 'add') {
                    _this.topic.addFiles(data.fileNames);
                    _this.message(event, data);
                }
                if (angular.isDefined(data.complete)) {
                    _this.topic.updateTopic(data.complete, true, []);
                    _this.topic.updateTopic(data.errors, true, []);
                }
            }
        });
        // If a main object needs to be updated, call this function,
        // it'll iterate over the array of object and updates objects, that are sent.
        this.socket.forward('topic.update.from.server', this.$scope);
        this.$scope.$on('socket:topic.update.from.server', function (event, data) {
            console.log('updating form server');
            if (!angular.isUndefined(data)) {
                if (_this.topic.topicBrowserID === data.bID) {
                    if (data.success) {
                        if (angular.isUndefined(data.partialResult)) {
                            _this.topic.updateTopic(data.response, false, []);
                        }
                        else {
                            _this.topic.updateTopic(data.partialResult, true, []);
                        }
                        _this.message(event, { msg: 'Update Successful' });
                    }
                    else {
                        _this.topic.calculateAccess(data.type, false);
                        console.log('displaying eror message', data.err);
                        _this.message(event, { err: true, msg: data.msg });
                    }
                }
                else {
                    _this.message(event, { err: true, msg: 'Page was reloaded since the update, reload your page - topic.update.from.server' });
                }
            }
            else {
                _this.message(event, { err: true, msg: 'Empty response - topic.update.from.server' });
            }
            ;
        });
        this.socket.forward('topic.update.tab', this.$scope);
        this.$scope.$on('socket:topic.update.tab', function (event, data) {
            if (data && data.tab && data.oppDocId) {
                _this.topic.setActiveTab(data.tab);
                _this.$state.go(data.tab, _this.$stateParams);
            }
        });
        //calculation v2 creation
        this.socket.forward('topic.calculation.created', this.$scope);
        this.$scope.$on("socket:topic.calculation.created", function (event, data) {
            _this.topic.calculation = data.calculation;
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            // Here I need to change the data.type to whatever that will reply to me the array of changed objects
            if (!angular.isUndefined(data)) {
                if (_this.topic.topicBrowserID === data.bID) {
                    if (data.success) {
                        if (angular.isDefined(data.eos)) {
                            _this.topic.updateEditOptions(data.eos, _this.topic.topic.program);
                        }
                        if (angular.isUndefined(data.partialResult)) {
                            angular.forEach(data.type, function (type) {
                                _this.topic.setTopicFromTempPart(type);
                                _this.topic.calculateAccess([type], false);
                            });
                        }
                        else {
                            // This is a hack... if something is newly-unlocked, the element in question
                            // is not sent back from the server and therefore is not processed correctly
                            // as an editable object without an F5... this adds it based on current data
                            // which will not have changed (since it was locked)
                            angular.forEach(data.partialResult, function (v, k) {
                                if (k.indexOf('lock_indicator.') > -1) {
                                    var locked_comp = k.substring('lock_indicator.'.indexOf(k) + 16);
                                    data.partialResult[locked_comp] = { add: true, data: _this.topic.topic[locked_comp] };
                                }
                            });
                            _this.topic.updateTopic(data.partialResult, true, data.type);
                            //If the update involves gpp data...perform the calculate...added by Matt @ 4 May 2017
                            if (data.type.indexOf('gpp') > -1) {
                                _this.topic.resetCompareGppData();
                                _this.topic.calculateGppDifference('gpp_live', 'gpp');
                            }
                            _this.topic.checkSubStatus(); // In case status object is part of the changes and is a system-set one
                            //If the update involves cmr_valid, re-enable the GOE Validation button
                            _this.topic.goeFired = false;
                        }
                        _this.message(event, { msg: 'Update Successful' });
                    }
                    else {
                        console.log('displaying eror message', 'err-' + data.err);
                        _this.topic.calculateAccess(data.type, false);
                        _this.message(event, { err: true, msg: data.err });
                    }
                }
                else {
                    _this.message(event, { err: true, msg: 'Page was reloaded since the update, reload your page - topic.update.partial' });
                }
            }
            else {
                _this.message(event, { err: true, msg: 'Empty response - topic.update.partial' });
            }
        });
        // config data from server
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            // here display the data from search & submit for approval
            if (_this.topic.topicBrowserID === data.bID) {
                if (data.success) {
                    if (_this.searchSubmit.checkIfReportLoaded()) {
                        var desc = _this.searchSubmit.getItemName(data.type[0]);
                        var items = {
                            cancelMessage: 'Ignore',
                            dialogName: 'Replace Search Results',
                            message: "A set of search results already exists in the <b>Process Later</b> section.\n                                <br><br>Do you want to replace the old results with the new <b> " + desc + " </b> results?",
                            okMessage: 'Replace'
                        };
                        _this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
                            if (dResult.confirm) {
                                _this.searchSubmit.updateSearchResults(data, $stateParams);
                                _this.topic.setActiveTab('searchsubmit');
                                _this.$state.go('detail.searchsubmit', {
                                    id: _this.$stateParams.id
                                });
                            }
                            else {
                                _this.topic.calculateAccess(data.type, false);
                            }
                            return;
                        });
                    }
                    else {
                        _this.searchSubmit.updateSearchResults(data, $stateParams);
                        _this.topic.setActiveTab('searchsubmit');
                        _this.$state.go('detail.searchsubmit', {
                            id: _this.$stateParams.id
                        });
                    }
                }
                else {
                    _this.message(event, data);
                    _this.topic.updatePartialSocketStatus(data.type, '');
                }
            }
            else {
                _this.message(event, {
                    err: true, msg: "No search saved! Page was reloaded from search submit or you opened another request,\n                while waiting for search response , start search again - topic.search.result" });
            }
        });
        this.socket.forward('settings.profile', this.$scope);
        this.$scope.$on('socket:settings.profile', function (event, data) {
            // Updates user profile
            if (!angular.isUndefined(data)) {
                _this.settings.updateProfile(data);
            }
            _this.topic.fromUserProfile();
            _this.message(event, data);
        });
        /* TEMP */
        this.socket.forward('config.settings', this.$scope);
        this.$scope.$on('socket:config.settings', function (event, data) {
            // Updates user profile
            //console.log('Received Global Settings', data); //REMOVE
            _this.settings.updateSettings(data);
            _this.topic.fromSettings();
            _this.topic.fromConfig();
        });
        this.topic.loaded = { config: false, topic: false };
        socket.forward('settings.update', $scope);
        this.$scope.$on('socket:settings.update', function (event, data) {
            //  this.settings.updateSettings(data);
            //  this.topic.fromSettings();
        });
        this.socket.forward('detail.validation', this.$scope);
        this.$scope.$on('socket:detail.validation', function (event, data) {
            _this.topic.loaded.gpp_valid = false;
            _this.topic.topic.gpp_valid = data.gpp_valid;
            _this.topic.temp.gpp_valid = data.gpp_valid;
            _this.topic.topic.solutionDecision = data.solutionDecision;
        });
        this.socket.forward('topic.search.export', this.$scope);
        this.$scope.$on('socket:topic.search.export', function (event, data) {
            if (angular.isDefined(data)) {
                if (data.err) {
                    _this.notify.error('There was a problem attempting to download the attachment: ' + data.msg + '.  If the problem persists please contact the DMT System Administrators for guidance.');
                    return;
                }
                data.name = decodeURIComponent(data.name);
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: data.fileType
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                if (data.type === 'searchResult') {
                    a.setAttribute('download', "DMT-Search-Report_" + d + ".xlsx");
                }
                else if (data.type === 'searchReport' || data.type === 'any') {
                    a.setAttribute('download', data.name);
                }
                else {
                    a.setAttribute('download', "DMT-Unknown-Filetype.???");
                }
                a.click();
            }
        });
        socket.forward('topic.general.response', $scope);
        this.$scope.$on('socket:topic.general.response', function (event, res) {
            if (res.type === 'otherContacts') {
                if (_this.topic.topicBrowserID === res.bID && res.success) {
                    var items = { table: res.table, dialogName: 'Other Contacts' };
                    _this.Dialog.updateValidForm(event, items, 'display-other-contacts.html').then(function (dResult) {
                        return;
                    });
                }
            }
        });
    }
    BodyController.prototype.$onInit = function () {
        //console.log('site.body => check user');
        this.$login.setUser();
        this.env.user.admin = false;
    };
    BodyController.prototype.message = function (ev, data) {
        //console.log(data);
        if (data.err) {
            return this.notify.error(data.msg);
        }
        this.notify.success(data.msg);
    };
    BodyController.$inject = ['$login', 'env', 'socket', '$scope', 'notify', '$state',
        '$stateParams', 'config', 'topic', '$rootScope', 'settings',
        'status', 'searchSubmit', 'Dialog', '$window', '$timeout'];
    return BodyController;
}());
var BodyComponent = (function () {
    function BodyComponent() {
        this.templateUrl = 'site-body.html';
        this.controllerAs = 'vm';
        this.controller = BodyController;
    }
    return BodyComponent;
}());
angular
    .module('application')
    .component('body', new BodyComponent());

//# sourceMappingURL=site.body.component.js.map
